import React, { useCallback, useState } from "react";
import { Form, Input, Button, Card } from "antd";
import "./index.scss";
import TextEditor from "../../../../components/TextEditor";
const { TextArea } = Input;

interface EmailFormProps {
  form: any;
  fixedBody: string;
  footerMessage: string;
  subject: string;
  isUserPermitted: boolean;
  emailFormValues?: any;
  setEmailFormValues?: any;
  setIsFormValuesChanged?: any;
  tableHtml?: any;
  isTable?: boolean;
}
const EmailForm: React.FC<EmailFormProps> = ({
  form,
  fixedBody,
  footerMessage,
  isUserPermitted,
  emailFormValues,
  setEmailFormValues,
  setIsFormValuesChanged,
  isTable = false,
  tableHtml = <></>,
}) => {
  const [errors, setErrors] = useState<{ to?: string; cc?: string }>({});

  const validateEmails = (value: string) => {
    if (!value) return "";
    const emails = value
      .split(/[, ]+/)
      .map((email: string) => email.trim())
      .filter((email: string) => email.length > 0);

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const invalidEmails = emails.filter(
      (email: string) => !emailRegex.test(email)
    );

    return invalidEmails.length > 0
      ? `Invalid email(s): ${invalidEmails.join(", ")}`
      : "";
  };

  const handleChange = useCallback(
    (field: "to" | "cc", value: string) => {
      const errorMsg = validateEmails(value);
      console.log(
        "🚀 ~ EmailForm ~ errorMsg:",
        errorMsg,
        "======",
        errorMsg.length
      );
      if (!!errorMsg.length) {
        setIsFormValuesChanged?.(false);
      } else {
        setIsFormValuesChanged?.(true);
      }
      setErrors((prev) => ({ ...prev, [field]: errorMsg }));
      setEmailFormValues?.({ ...emailFormValues, [field]: value });
    },
    [emailFormValues, setEmailFormValues, setIsFormValuesChanged]
  );
  return (
    <div
      style={{ background: "#F6F7F8", borderRadius: "0.5rem", padding: "2rem" }}
    >
      <div className="custom-email-form">
        {/* To */}
        <Form.Item
          label="To"
          required
          {...(!("to" in (emailFormValues || {}))
            ? { name: ["emailContent", "to"] }
            : {})}
          validateTrigger="onSubmit"
          rules={[
            { required: true, message: "Please enter recipient email(s)" },
            {
              validator: (_, value) => {
                if (!value) {
                  return Promise.resolve();
                }

                // Split by comma or space
                const emails = value
                  .split(/[, ]+/)
                  .map((email: string) => email.trim())
                  .filter((email: string) => email.length > 0);

                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                const invalidEmails = emails.filter(
                  (email: string) => !emailRegex.test(email)
                );

                return invalidEmails.length === 0
                  ? Promise.resolve()
                  : Promise.reject(
                      `Invalid email(s): ${invalidEmails.join(", ")}`
                    );
              },
            },
          ]}
          className="send-to-label"
          validateStatus={errors.to ? "error" : ""}
          help={errors.to}
        >
          <Input
            placeholder="Enter recipient email"
            readOnly={!isUserPermitted}
            value={
              "to" in (emailFormValues || {}) ? emailFormValues?.to : undefined
            }
            autoComplete="off"
            onChange={(e) => handleChange("to", e.target.value)}
          />
        </Form.Item>

        {/* CC */}
        <Form.Item
          label="CC"
          required
          {...(!("cc" in (emailFormValues || {}))
            ? { name: ["emailContent", "cc"] }
            : {})}
          className="cc-email-label"
          validateStatus={errors.cc ? "error" : ""}
          help={errors.cc}
          rules={[{ required: true, message: "Please enter recipient email(s)" }]}
        >
          <Input
            placeholder="Enter CC email(s)"
            style={{ marginLeft: "1rem" }}
            readOnly={!isUserPermitted}
            autoComplete="off"
            value={
              "cc" in (emailFormValues || {}) ? emailFormValues?.cc : undefined
            }
            onChange={(e) => handleChange("cc", e.target.value)}
          />
        </Form.Item>

        {/* Subject */}
        <Form.Item
          label="Subject"
          name={["emailContent", "subject"]}
          rules={[{ required: true, message: "Please enter subject" }]}
        >
          <Input placeholder="Enter subject" readOnly autoComplete="off" />
        </Form.Item>

        <Form.Item label="Body" style={{ marginBottom: 0 }}>
          <div
            style={{
              border: "1px solid #d9d9d9",
              borderRadius: "6px",
              padding: "8px",
              background: "#fff",
              // whiteSpace: "pre-wrap",
              marginLeft: "2rem",
            }}
          >
            {/* Fixed prefix */}

            <div
              style={{ margin: 0, padding: 0, lineHeight: "1.4" }}
              dangerouslySetInnerHTML={{ __html: fixedBody }}
            />
            {!!isTable && (
              <div
                style={{ margin: 0, padding: 0, lineHeight: "1.4" }}
                dangerouslySetInnerHTML={{ __html: tableHtml }}
              />
            )}

            {/* Editable message only */}
            <Form.Item
              noStyle
              {...(!("message" in (emailFormValues || {}))
                ? { name: ["emailContent", "message"] }
                : {})}
              style={{ marginBottom: 0 }}
            >
              <TextArea
                autoSize={{ minRows: 3 }}
                placeholder="Type your message here..."
                style={{
                  border: "none",
                  boxShadow: "none",
                  resize: "none",
                  width: "100%",
                }}
                readOnly={!isUserPermitted}
                autoComplete="off"
                value={
                  "message" in (emailFormValues || {})
                    ? emailFormValues?.message
                    : undefined
                }
                onChange={(e) => {
                  setEmailFormValues?.({
                    ...emailFormValues,
                    message: e.target.value,
                  });
                  setIsFormValuesChanged?.(true);
                }}
              />
            </Form.Item>

            {/* Fixed suffix */}
            <div style={{ color: "#555" }}>
              <div
                style={{ margin: 0, padding: 0, lineHeight: "1.4" }}
                dangerouslySetInnerHTML={{ __html: footerMessage }}
              />
            </div>
          </div>
        </Form.Item>
      </div>
    </div>
  );
};

export default EmailForm;
